import React from "react";

const NormalQuestion = ({NormalQuestion}) =>{
    return(
        <div className="document-upload-question">
            
                <img src="/images/chatbot-icon.png" alt="chatbot"/>

        
            <div className="document-upload-question-content">
                <div className="document-upload-question-content-title">
                    {NormalQuestion}

                </div>
            </div>
        </div>
    )
}

export default NormalQuestion;